import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { AlertService } from '@app/_services';
import { TaskService } from '@app/_components/task';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class TaskResolver  {

	constructor(
		private router: Router,
		private taskService: TaskService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.taskService.findById(+activatedRouteSnapshot.paramMap.get('taskId'));
	}
}
